import messages from './messages';

const giftCardNumberRegex = /^(\(|\)|\d{19})$/;
const giftCardPinRegex = /^(\(|\)|\d{4})$/;

export default (values, { formatMessage, isExpanded, formSubmitted }) => {
  const errors = {};

  if (formSubmitted && isExpanded) {
    if (!values.giftCardNumber) {
      errors.giftCardNumber = formatMessage(messages.required);
    }

    if (!values.giftCardPin) {
      errors.giftCardPin = formatMessage(messages.required);
    }
  }

  if (values.giftCardNumber &&
    !giftCardNumberRegex.test(values.giftCardNumber)) {
    errors.giftCardNumber = formatMessage(messages.invalidGiftCardNumber);
  }

  if (values.giftCardPin && !giftCardPinRegex.test(values.giftCardPin)) {
    errors.giftCardPin = formatMessage(messages.invalidGiftCardPin);
  }

  return errors;
};
